import {extras} from './mockParts/extras'
import { pqs_1, pqs_2 } from './mockParts/priceQuotes'
import { airports } from './mockParts/airports'
import { card_1, card_2, card_3, card_4 } from './mockParts/cards';
import { TravelCareType } from './enums';
import { passenger_1 } from './mockParts/passengers';

export default {
  'airlines': {
    'UA': {
      'id':'123',
      'code': 'UA',
      'name': 'United Airlines',
      'img': 'https:\/\/pay.travelbusinessclass.com\/build\/icons\/airline\/UA.png'
    },
    'AC': {
      'id': '97',
      'code': 'AC',
      'name': 'Air Canada',
      'img': 'https:\/\/pay.travelbusinessclass.com\/build\/icons\/airline\/AC.png'
    }
  },
  'airports': airports,
  'passengers': {'adult': 1, 'child': 0, 'infant': 0, 'all': 1},
  'extras': extras,
  'operatorInfo': {
    'name': 'Admin Admin',
    'online': true,
    'img': 'https:\/\/bo2.travelbusinessclass.com\/\/storage\/7f647af2-e9bc-450b-a1e7-1a32f59e0974.jpg',
    'email': 'admin@tbc.loc',
    'phone': '+11111111111'
  },
  'customer': {'first_name': 'Baljit', 'last_name': 'Singh Ghotra'},
  'current_year': '2024',
  'lead_id': '2569991',
  'user_ip': '188.244.18.23',
  'priceQuotes': pqs_2,
  'result': {
    'user_ip': '192.168.1.1',
    'flight': 'A1002',
    'confirmTerms': true,
    'splitPayment': true,
    'manualSplit': false,

    'contactPhoneNumber': '+1 (855) 855-1221',
    'itinerarySwitch': true,
    'contactDetailsSwitch': true,
    'email': 'james@travelbusinessclass.com',

    'passengers': [
        passenger_1
    ],

    // 'cardsAmmount': [4000, 7770, 300],
    'cardsAmmount': [],
    'cards': [ card_1, card_2, card_3],

    'tips': 0,
    "acceptTips": false,
    "travelCare": TravelCareType.Decline,

    'totalAmount': '12770',
    'token': 'df793ec0-cda9-4a83-ad08-db82054b0a08',
  }

// only for 0 amount
//   'result':{
//     "cards": [],
//     "tips": 0,
//     "acceptTips": false,
//     "travelCare": 'declineProtection',
//   }
}
